import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const generatePayload = ({ attendanceId, schedule }) => {
  return {
    schedules: [
      {
        id: attendanceId,
        bus_schedule_id:
          schedule.outbound_required || schedule.return_required
            ? (schedule.bus_schedule_id ?? null)
            : null,
        outbound_bus_route_id: schedule?.outbound_required
          ? (schedule.outbound_bus_route_id ?? null)
          : null,
        outbound_passengers: schedule?.outbound_required
          ? schedule.outbound_extra_passengers + 1
          : 0,
        return_bus_route_id: schedule?.return_required
          ? (schedule.return_bus_route_id ?? null)
          : null,
        return_passengers: schedule?.return_required
          ? schedule.return_extra_passengers + 1
          : 0,
      },
    ],
  };
};

export const putAttendanceBusSchedules = ({ data, attendanceId }) => {
  return api.put(`/admin/attendance-bus-schedules/${attendanceId}`, data);
};

// Hook for posting retake attendances
export const usePutAttendanceBusSchedules = ({ mutationConfig } = {}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    mutationFn: putAttendanceBusSchedules,
    onSuccess: async (data, ...args) => {
      if (onSuccess) {
        await onSuccess(data, ...args);
      }
      queryClient.resetQueries();
    },
    ...restConfig,
  });
};
